<template>
  <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g :filter="`url(#${filterId})`">
      <path
        d="M8.41201 13.0901L3.21356 16L4.37442 10.1566L0 6.11166L5.91634 5.40999L8.41201 0L10.9077 5.40999L16.824 6.11166L12.4496 10.1566L13.6105 16L8.41201 13.0901Z"
        fill="#140047"
        fill-opacity="0.14"
      />
    </g>
    <path
      d="M4.37442 10.1567L0 6.11171L2.95817 5.76087L4.43726 5.58545L4.37442 10.1567Z"
      :fill="`url(#${gradientId})`"
    />
    <defs>
      <filter
        :id="filterId"
        x="0"
        y="0"
        width="16.824"
        height="16"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="2" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0784314 0 0 0 0 0 0 0 0 0 0.278431 0 0 0 0.05 0"
        />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_471_4930" />
      </filter>
      <linearGradient
        :id="gradientId"
        x1="2.21863"
        y1="5.58545"
        x2="2.21863"
        y2="10.1567"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FFB000" />
        <stop offset="1" stop-color="#FF7F00" />
      </linearGradient>
    </defs>
  </svg>
</template>

<script>
import { getUniqueId } from '@/plugins/uniqueId';

export default {
  name: 'star-2-10th',
  computed: {
    filterId: getUniqueId,
    gradientId: getUniqueId,
  },
};
</script>
